import SwitchCheckedHHMTIcon from 'assets/icons/switch-checked-hhmt-icon.svg';
import SwitchCheckedRemoxIcon from 'assets/icons/switch-checked-remox-icon.svg';
import SwitchboxHHMTIcon from 'assets/icons/switchbox-hhmt-icon.svg';
import SwitchboxRemoxIcon from 'assets/icons/switchbox-remox-icon.svg';
import { RESET_PII_PROFILE_RESIDENTIAL_ADDRESS } from 'features/pii/const';
import { Fade } from 'helpers/animation';
import useFormInput from 'hooks/form/useFormInput';
import useLang from 'hooks/useLang';
import useTheme from 'hooks/useTheme';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import { cursorPointerMixin, paragraph500Mixin } from 'styles';

const FormInputAddressFinderManualSwitch = ({
  field,
  information,
  setInformation,
  setValidation,
}) => {
  const { t } = useLang();
  const { isHHMTTheme } = useTheme();

  const { setInformationFormInput } = useFormInput(field);

  const isEnterAddressManual = Boolean(information[field.name]);

  const handleOnChange = () => {
    setInformationFormInput({
      value: !isEnterAddressManual,
      information: { ...information, ...RESET_PII_PROFILE_RESIDENTIAL_ADDRESS },
      setInformation,
    });
    setValidation(RESET_PII_PROFILE_RESIDENTIAL_ADDRESS);
  };

  return (
    <FormGroupStyled onClick={handleOnChange}>
      <FormSwitch
        type="switch"
        label={t(field.label)}
        name={field.name}
        checked={isEnterAddressManual}
        $checkboxSrc={isHHMTTheme ? SwitchboxHHMTIcon : SwitchboxRemoxIcon}
        $checkedSrc={
          isHHMTTheme ? SwitchCheckedHHMTIcon : SwitchCheckedRemoxIcon
        }
        readOnly
      />
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled.div`
  position: relative;
  ${Fade};
`;

const FormSwitch = styled(Form.Check)`
  margin: 0;
  margin-right: 44px;

  label {
    ${paragraph500Mixin};
    ${cursorPointerMixin};
    margin-left: 8px;
    height: 32px;
    display: flex;
    align-items: center;
    padding-block: 4px;
  }

  input:checked[type='checkbox'] {
    background-image: ${(props) => `url(${props.$checkedSrc}) !important`};
    background-position: center !important;
  }

  input {
    border: none;
    border-radius: 2px;
    background-image: ${(props) => `url(${props.$checkboxSrc}) !important`};
    background-position: center !important;
    width: 40px !important;
    height: 24px !important;
    cursor: pointer !important;

    &:focus,
    &:active,
    &:checked {
      background-color: transparent;
      border: none;
      border-radius: 2px;
      box-shadow: none !important;
      filter: none !important;
    }
  }
`;

export default FormInputAddressFinderManualSwitch;
